import * as React from "react";
import classnames from "classnames";
import { FacetPickerHeader } from "./FacetPickerHeader.js";
/* empty css                 */
const FacetPicker = ({
  onPick,
  itemComponent,
  facetTermFormatter: FacetTermFormatter,
  activeFacet,
  items,
  title,
  className,
  rightSlot,
  shouldShowFacetName,
  productType
}) => {
  const ItemComponent = itemComponent;
  return /* @__PURE__ */ React.createElement("div", { className: classnames("facet-picker", className) }, /* @__PURE__ */ React.createElement(FacetPickerHeader, { rightSlot }, title), shouldShowFacetName && /* @__PURE__ */ React.createElement("div", { className: "facet-picker__info", "data-t": "facet-picker__info" }, activeFacet?.facetTerm), /* @__PURE__ */ React.createElement("div", { className: "facet-picker__facets", "data-t": "facet-picker-facets" }, /* @__PURE__ */ React.createElement(
    "ul",
    {
      className: classnames(`facet-picker__tiles`, {
        "facet-picker__tiles--single": items.length == 1,
        [`${className}__tiles`]: className
      }),
      "aria-label": title
    },
    items.map((item) => {
      const isActive = item.facetTerm === activeFacet?.facetTerm && item.sku === activeFacet?.sku;
      return /* @__PURE__ */ React.createElement(
        "li",
        {
          key: item.sku,
          className: classnames(`facet-picker__item`, { [`${className}__item`]: className }),
          "aria-current": isActive || void 0
        },
        /* @__PURE__ */ React.createElement(
          ItemComponent,
          {
            isActive,
            item,
            onPick,
            productType
          },
          FacetTermFormatter && /* @__PURE__ */ React.createElement(FacetTermFormatter, { facetTerm: item.facetTerm })
        )
      );
    })
  )));
};
export {
  FacetPicker
};
//# sourceMappingURL=FacetPicker.js.map
